import { Candidate, VideoUploadQuestionResponse } from '../../../../../firebase/firestore/documents/candidate';
import { Position } from '../../../../../firebase/firestore/documents/position';

export interface VideoResponseQuestionItem extends VideoUploadQuestionResponse {
  answered: boolean;
}

export default class VideoResponsePresenter {
  readonly questions: VideoResponseQuestionItem[];

  constructor(position: Position, candidate?: Candidate) {
    const responses = candidate?.videoUploadQuestionResponses ?? [];
    const positionQuestions = position.videoUploadQuestions ?? [];

    const responseMap = new Map(responses.map((r) => [r.id, r]));

    // monetized: only show questions candidate has responded to
    const questions = candidate?.monetized ? positionQuestions.filter((q) => responseMap.has(q.id)) : positionQuestions;

    this.questions = questions.map((q) => {
      const response = responseMap.get(q.id);
      return {
        ...response,
        id: q.id,
        question: q.question,
        isActive: q.isActive,
        isSkippable: q.isSkippable,
        questionOrder: q.questionOrder,
        maximumVideoDuration: q.maximumVideoDuration,
        answer: response?.answer_hls ?? response?.answer ?? null,
        answered: !!response?.answer_hls || !!response?.answer,
      } as VideoResponseQuestionItem;
    });
  }

  getQuestionsCount(): number {
    return this.questions.length;
  }

  getAnsweredQuestionsCount(): number {
    return this.questions.filter((q) => !!q.answer).length;
  }

  hasAnyAnswered(): boolean {
    return this.questions.some((q) => !!q.answer);
  }
}
